import React from 'react'
import { useRef } from 'react'

import { Grid, Paper,makeStyles } from '@material-ui/core'

import AddButtonAbm from '../../compartidos/abms/AddButtonAbm'
import EditButtonAbm from '../../compartidos/abms/EditButtonAbm'
import TableGeneric from '../../compartidos/abms/TableGeneric'
import DeleteButtonAbm from '../../compartidos/abms/DeleteButtonAbm'
import { useDispatch, useSelector } from 'react-redux'
import { deleteLiquidador, getLiquidadores, postLiquidador, updateLiquidador } from '../../../actions/liquidaciones/efectoresPorLiquidador'
import { EFECTORES_LIQUIDADOR_PERMISOS } from '../../../utils/permisos'
import { useEffect } from 'react'
import { fetchUsuariosPorArea } from '../../../actions/usuarios/usuarios'
import { AREAS_USUARIOS } from '../../../utils/constants'
// import { ModalEfectores } from './ModalEfectores'
import { FormLiquidador } from './FormLiquidador'
import { fetchLocalidades } from '../../../actions/cbos/localidades'
import { fetchProvincias } from '../../../actions/cbos/provincias'

const useStyles = makeStyles((theme) => ({
  root: {
      flexGrow: 1,
      marginTop: theme.spacing(2)
  },
  center: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
  },
}));

export const HomeEfectoresPorLiquidador = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const componentRef = useRef();

  const { liquidadores } = useSelector((state) => state.efectoresPorLiquidador);
  const { items: localidades } = useSelector((state) => state.localidades);
  const { items: provincias } = useSelector((state) => state.provincias);
  const { items: usuarios } = useSelector((state) => state.usuarios);

  const handleSave = (formValues, handleClose) => {
    dispatch(postLiquidador(formValues, handleClose));
  }
  const handleEdit = (formValues, handleClose) => {
    dispatch(updateLiquidador(formValues, handleClose));
  }
  const handleDelete = (idLiquidador) => {
    dispatch(deleteLiquidador(idLiquidador));
  }
  
  useEffect(() => {
    if (liquidadores.length === 0) {
      dispatch(getLiquidadores());
    }
    if (usuarios.length === 0) {
    dispatch(fetchUsuariosPorArea(AREAS_USUARIOS.LIQUIDACIONES));
    }
    if (localidades.length === 0) {
      dispatch(fetchLocalidades());
    }
    if (provincias.length === 0) {
        dispatch(fetchProvincias());
    }
  }, [])

  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={1}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12} style={{textAlign: 'right', marginBottom: "2rem"}}>
          <AddButtonAbm
            title="Agregar Liquidador"
            handleSave={handleSave}
            permiso={EFECTORES_LIQUIDADOR_PERMISOS.ALTA}
            form={FormLiquidador}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid container justify="space-between" alignItems="center" component={Paper} spacing={2}>
            <Grid item xs={12}>
              <TableGeneric
                ref={componentRef}
                data={liquidadores}
                withoutPagination={false}
                tituloSinResultado="No hay liquidadores en lista"
                rowPerPage={10}
                columns={[
                  {
                    label: "",
                    id: "",
                    customBody: (item) => (
                      <>
                        <EditButtonAbm
                          title="Editar Liquidador"
                          handleSave={handleEdit}
                          permiso={EFECTORES_LIQUIDADOR_PERMISOS.MODIFICACION}
                          item={item}
                          form={FormLiquidador}
                        />
                        <DeleteButtonAbm
                          handleDelete={() => handleDelete(item.idLiquidador)}
                          permiso={EFECTORES_LIQUIDADOR_PERMISOS.BAJA}
                          mensajeEliminacion="¿Desea anular este usuario?"
                        />
                      </>
                    )
                  },
                  {
                    label: "Usuario",
                    id: "descripcion",
                    sort: true,
                  },
                  // {
                  //   label: "Efectores",
                  //   id: "efectoresPorLiquidador",
                  //   customBody: (item) => 
                  //     <ModalEfectores  
                  //       item={item.efectoresPorLiquidador} 
                  //     />
                  // },
                ]}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}
